import { render } from "./MessageUnit.vue?vue&type=template&id=f55ea3aa&scoped=true"
import script from "./MessageUnit.vue?vue&type=script&lang=js"
export * from "./MessageUnit.vue?vue&type=script&lang=js"

import "./MessageUnit.vue?vue&type=style&index=0&id=f55ea3aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55ea3aa"]])

export default __exports__